export const ACCOUNT = Object.freeze({
  SESSION_EXPIRED: 'sessionExpired',
  SESSION_EXPIRED_MODAL_TITLE: 'Thank you for visiting!',
  SESSION_EXPIRED_MODAL_MESSAGE: 'Your session has expired due to inactivity. Please login to continue.'
})
